// extracted by mini-css-extract-plugin
export default {"header":"Header-module__[local]___whJKN","title":"Header-module__[local]___ICE-i"};